import { HfsSettingsActionEnum } from 'fleet-data-model';
import { type Update } from '../../types';

export const mapSpotCuttingExecutionTargets = (update: Update) => [
  {
    hfsActionId: HfsSettingsActionEnum.SPOT_CUTTING_ENABLED,
    iprId: update.assetId,
    payload: {
      enabled: update.enabled,
    },
  },
];
